module.exports = "data:font/ttf;base64,"